import React, { Component, Fragment } from "react"
import { OnboardingHeader } from "components/OnboardingHeader"
import ProgressMeterWithLogo from "components/ProgressMeterWithLogo"
import { Button, Input, Icon } from "@drifthq/tide-core"
import { pathOr, endsWith, length, isEmpty } from 'ramda'
import cx from 'classnames'
import BackButton from "components/OnboardingBackButton"
import { DisabledButton } from "components/OnboardingDisabledButton"
import { PLAYBOOK_TYPES } from 'layouts/OnboardingPlaybookPickBotStep'

import "./style.css"

const DISABLED_TOOLTIP = <div>Please add at least one URL<br />before proceeding</div>


class BotTargeting extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pathList: [''],
      errors: [false]
    }
  }

  handleAdd = () => {
    const { pathList, errors } = this.state
    let creationErrors = errors.slice()
    if (pathList.some(isEmpty)) {
      const newIndex = length(pathList)
      creationErrors[newIndex] = true
    }
    this.setState({ pathList: pathList.concat(['']), errors: creationErrors })
  }

  handleRemove = (index) => {
    const { pathList } = this.state
    const newPathList = pathList.filter((_, i) => i !== index)
    let removalErrors = new Array(length(newPathList)).fill(false);
    let uniquePaths = []
    for (let j in newPathList) {
      var path = newPathList[j]
      uniquePaths.includes(path) ? removalErrors[j] = true : uniquePaths[index] = path
    }
    this.setState({ pathList: newPathList, errors: removalErrors })
  }

  showCancelButton = (index) => {
    return index > 0 //one path is required
  }

  renderAddPageLink = () => (
    <Button className="bot-targeting-page-add"
      type="subtle"
      onClick={this.handleAdd}>
      &#65291; Add another page
    </Button>
  )

  handleInputChange = (event, index) => {
    const changedValue = pathOr('', ['target', 'value'], event)
    let p = this.state.pathList.slice()
    let e = this.state.errors.slice()

    e[index] = p.includes(changedValue)
    p[index] = changedValue;
    this.setState({ pathList: p, errors: e })
  }

  renderInputArea = (text, index) => {
    const { pathList, errors } = this.state
    const { companyUrl } = this.props
    return (
      <Fragment>
      <div className={cx('bot-targeting-input-wrapper', {'bot-targeting-input-wrapper--first' : index === 0})} key={index}>
        <div className="bot-targeting-input-label">{endsWith('/', companyUrl) ? companyUrl : `${companyUrl}/`}</div>
        <div className="bot-targeting-input-field">
          <Input
            className={cx('bot-targeting-input', {'bot-targeting-input-invalid' : !!errors[index]})}
            value={pathList[index]}
            onChange={(event) => this.handleInputChange(event, index)}
          />
          <div className="input-cancel-button">
            {this.showCancelButton(index) && <div onClick={() => this.handleRemove(index)}>
              <Icon className="no-cancel-button" name="cancel-circle" /></div>}</div>
        </div>
      </div>
      {errors[index] && <span className="bot-targeting-input-error">Whoops! Your URL paths need to be different from each other</span>}
      </Fragment>
    )
  }

  isFormValid = () => {
    return this.state.errors.every(e => !e)
  }

  onBuildBot = () => {
    const { onContinue, playbookType, actions: {createNewsletterPlaybook, createDemoRequestPlaybook}, companyUrl } = this.props
    const { pathList } = this.state
    const cleanPathList = pathList.filter(path => path = !!path).map(path => '/' + path)
    const targetingUrl = pathList.some(isEmpty) ? companyUrl : ''
    if (playbookType === PLAYBOOK_TYPES.NEWSLETTER) {
      createNewsletterPlaybook({
        targetingUrlList: cleanPathList,
        targetingUrl: targetingUrl
      })
    }
    else if (playbookType === PLAYBOOK_TYPES.DEMO_REQUEST) {
      const { productName, valueProp, industry } = this.props
      createDemoRequestPlaybook({
        productName: productName,
        valueProp: valueProp,
        industry: industry,
        targetingUrlList: cleanPathList,
        targetingUrl: targetingUrl
      })
    }
    onContinue()
  }

  render() {
    const { index, stepCount } = this.props
    const { pathList } = this.state
    return (
      <Fragment>
        <ProgressMeterWithLogo currentLength={index} maxLength={stepCount - 1} />
        <OnboardingHeader title="What page should this bot be on?" description="Don’t worry — we won’t add your bot to this page until you turn it on" />
        {!!pathList && pathList.map(this.renderInputArea)}
        {this.renderAddPageLink()}
        {this.isFormValid() ? <Button onClick={this.onBuildBot} className="bot-targeting-build-button" size="large">
          Build my bot!
        </Button> : <DisabledButton buttonClassName="bot-targeting-build-button--width" buttonText="Build my bot!" toolTipText={DISABLED_TOOLTIP} />}
        <BackButton />
      </Fragment>
    )
  }
}

export default BotTargeting



// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookTargetingStep/BotTargeting/index.js